module.exports = __webpack_public_path__ + "static/Manufacturing-Photo1-3341ecc661c605b3dd6757f21bdf16f2.png";